// @flow
export { default } from "lodash/fp/throttle"
